<template>
  <div 
    id="devolucoes-sem-finaceiro" 
    class="w3-container w3-margin-top" 
    style="margin:0 -10px">
    
    <div class="w3-col s12 m12 l12 w3-margin-bottom" v-if="processando">
      <div class="w3-panel w3-theme w3-card-2">
        <p><i class="fa fa-sync-alt w3-spin"></i> Processando...</p>
      </div>
    </div>

    <div v-if="!processando" class="w3-margin-bottom">
      <input
        class="w3-input w3-border w3-padding margin-bottom-filtro"
        v-model="filtro"
        type="text"
        placeholder="Pesquise por nome ou código"
        v-on:keyup="filtrarDevolucoes()">
    </div>

    <div
      class="w3-panel w3-text-theme w3-bottombar w3-border-theme w3-border w3-animate-left"
      v-if="!processando && ((!fornecedores) || (fornecedores.length == 0))"
      v-cloak>

      <div class="w3-container w3-white">
        <p>Não há devoluções a serem exibidas.</p>
      </div>
    </div>

    <div
      class="wrapper-componente"
      v-if="!processando && (fornecedores) && (fornecedores.length > 0)">

      <div
        v-for="(fornecedor, indice_fornecedor) in fornecedoresFiltrados"
        :key="indice_fornecedor"
        class="card-item w3-col"
        @click="mostrarDetalhes(indice_fornecedor)"
        :class="{'tr-items-ativo': fornecedor.mostrar_detalhes}">

        <div class="w3-col s12 w3-text-theme">
          <strong>{{fornecedor.fornecedor_id}} - {{fornecedor.nome_razao_social}}</strong>
        </div>

        <div class="w3-col s12">
          <label>Qtd. notas: </label>
          <strong>{{fornecedor.quantidade_notas}}</strong>
        </div>

        <div class="w3-col s12">
          <label>Total notas: </label>
          <strong>R$ {{fornecedor.total_notas}}</strong>
        </div>

        <div v-if="fornecedor.mostrar_detalhes">
          <div
            v-for="(nota, idx_nota) in fornecedor.notas_devolucoes"
            :key="idx_nota"
            class="card-item w3-col"
            style="background-color: #ffffff; color: #000000;">

            <div class="w3-col s12">
              <label>Devolução: </label>
              <strong>{{nota.devolucao_compra_id}}</strong>
            </div>

            <div class="w3-col s12">
              <label>Nr. nota fiscal: </label>
              <strong>{{nota.numero_nota}}</strong>
            </div>

            <div class="w3-col s12">
              <label>CFOP: </label>
              <strong>{{nota.cfop_id}}</strong>
            </div>

            <div class="w3-col s12">
              <label>Data cadastro: </label>
              <strong>{{nota.data_cadastro}}</strong>
            </div>

            <div class="w3-col s12">
              <label>Valor da nota: </label>
              <strong>{{nota.valor_total_nota}}</strong>
            </div>

            <div class="w3-col s12">
              <label>Empresa: </label>
              <strong>{{nota.empresa_id}} - {{nota.nome_resumido_empresa}}</strong>
            </div>
          </div>
        </div>
      </div>

      <paginacao
        @pagina="mudarPagina"
        :pagina-atual="pagina_atual"
        :itens-por-pagina="itens_por_pagina"
        :total-resultados="total_resultados"
        :total-de-paginas="total_de_paginas"/>
    </div>
  </div>
</template>

<script>  
  import toastr from 'toastr'
  import Paginacao from '@/components/Paginacao'
  import Biblioteca from '@/components/Repositorio/Biblioteca.js';
  import RDevolucaoCompra from '@/components/Rest/RDevolucaoCompra.js'
  
  export default {
    name: 'NotasDevolucoesComprasPendentes',

    components: {
      Paginacao
    },

    data() {
      return {
        filtro: '',
        processando: false,
        fornecedores: [],
        fornecedores_filtrados: [],

        pagina_atual: 0,
        itens_por_pagina: 10,
        total_resultados: 0,
        total_de_paginas: 0
      }
    },

    mounted() {
      $('html,body').stop().animate(
        {scrollTop: 0}, 
        'slow', 
        'swing'
      );
    },

    methods: {
      mudarPagina(numero_da_pagina) {
        this.pagina_atual = numero_da_pagina;
      },
      
      filtrarDevolucoes() {
        this.fornecedores_filtrados = [];
        this.mudarPagina(0)

        if(this.filtro == '') {
          this.fornecedores_filtrados = JSON.parse(JSON.stringify(this.fornecedores));
          return;
        }

        for (let i = 0; i < this.fornecedores.length; i++) {
          let filtro_pesquisa = Biblioteca.retirarCaracteres(this.filtro + '', ['.']).toUpperCase();

          let termo = Biblioteca.retirarCaracteres(this.fornecedores[i].fornecedor_id + '', ['.']);
          if (termo.indexOf(filtro_pesquisa) > -1) {
            this.fornecedores_filtrados.push(this.fornecedores[i]);
            continue;
          }

          termo = this.fornecedores[i].nome_razao_social.toUpperCase() + '';
          if (termo.indexOf(filtro_pesquisa) > -1) {
            this.fornecedores_filtrados.push(this.fornecedores[i]);
            continue;
          }

          let achou_nota = false;
          for (let j = 0; j < this.fornecedores[i].notas_devolucoes.length; j++) {
            termo = Biblioteca.retirarCaracteres(
              this.fornecedores[i].notas_devolucoes[j].devolucao_compra_id + '', 
              ['.']
            );
            if (termo.indexOf(filtro_pesquisa) > -1) {
              achou_nota = true;
              break;
            }
            
            termo = Biblioteca.retirarCaracteres(
              this.fornecedores[i].notas_devolucoes[j].numero_nota + '', 
              ['.']
            );
            if (termo.indexOf(filtro_pesquisa) > -1) {
              achou_nota = true;
              break;
            }
          }

          console.log(achou_nota)
          if (achou_nota) {
            this.fornecedores_filtrados.push(this.fornecedores[i]);
            continue;
          }
        }
      },
      
      mostrarDetalhes(indice_fornecedor) {
        this.fornecedores_filtrados[indice_fornecedor].mostrar_detalhes = !this.fornecedores_filtrados[indice_fornecedor].mostrar_detalhes;
        this.fornecedores_filtrados = JSON.parse(JSON.stringify(this.fornecedores_filtrados))
      },
      
      async buscarNotasDevolucoes() { 
        try {
          let retorno = await RDevolucaoCompra.buscarNotasDevolucoesCompraPendentesDashboard(this.axios);
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          this.fornecedores = JSON.parse(JSON.stringify(retorno.dados));
          this.fornecedores_filtrados = JSON.parse(JSON.stringify(retorno.dados));
          this.processando = false;
        } 
        catch (error) {
          toastr.error(error.message);
          this.processando = false;     
        }
      }
    },

    created() {
      this.buscarNotasDevolucoes();
    },

    computed: {
      fornecedoresFiltrados() {
        this.total_resultados = this.fornecedores_filtrados.length;
        this.total_de_paginas =  Math.ceil(this.total_resultados / this.itens_por_pagina);

        if (this.pagina_atual >= this.total_de_paginas) { 
          this.pagina_atual = this.total_de_paginas;
        }
        var index = this.pagina_atual * this.itens_por_pagina;
        return this.fornecedores_filtrados.slice(index, index + this.itens_por_pagina);
      }
    }
  }
</script>

<style scoped>
  .card-item {
    font-size: 15px;
    background: #fff;
    border-radius: 10px;
    margin-bottom: 12px;
    padding: 5px !important;
    border: 2px solid #ccc;
    box-shadow: #ccc 2px 2px 5px 2px;
  }

  .tr-items:hover {
    background: #9c1d1cb8;
    color:#fff;
    cursor: pointer;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .tr-items-ativo {
    background: rgb(235, 235, 235);
    
  }

  .mapa-financeiro-card {
    padding: 0 !important
  }

  .wrapper-componente {
    overflow: auto;
  }

  @media screen and (max-width: 767px){
    .wrapper-componente{
      font-size: 12px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/NotasDevolucoesComprasPendentes.vue